import React from 'react';
import './MainContainer.scss';

export default props => (
  <section className='main-container'>
    <div className='main-container__center'>{props.children}</div>
  </section>
);
